import EcommerceContainer from "../../../../Components/General/Dashboards/Ecommerce/EcommerceContainer";

const Ecommerce = () => {
  return <EcommerceContainer />;
};

export default Ecommerce;
